import { Box, chakra, Flex, keyframes } from "@chakra-ui/react";
import { shadows } from "lib/theme";
import { space } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const SwiperBox = chakra(Box, {
  baseStyle: {
    ".swiper": {
      width: "100%",
      height: "100%"
    },
    ".swiper-pagination-bullet": {
      backgroundColor: colours.primary.medium
    },
    ".swiper-pagination": {
      bottom: "30px !important"
    },
    ".swiper-pagination-bullet-active": {
      backgroundColor: colours.accent.deep
    },
    ".swiper-button-disabled": {
      opacity: "0 !important"
    },
    ".swiper-button-next:after, .swiper-button-prev:after": {
      content: "''"
    },
    ".swiper-button-next": {
      right: 0,
      marginTop: "-1.25rem !important",
      border: "1px solid transparent"
    },
    ".swiper-button-prev": {
      left: 0,
      marginTop: "-1.25rem !important",
      border: "1px solid transparent"
    },
    ".swiper-button-next, .swiper-button-prev": {
      visibility: "hidden",
      color: colours.primary.dark,
      background: "transparent"
    },
    ".swiper-button-next:active, .swiper-button-prev:active": {
      background: colours.primary.dark,
      color: colours.secondary.light
    },
    ".thumbs-swiper-slide.swiper-slide-thumb-active": {
      position: "relative",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "100%",
        height: space[-2],
        background: colours.primary.dark,
        top: 0,
        left: 0
      }
    }
  }
});

export const MainSwiper = chakra(SwiperBox, {
  baseStyle: {
    width: "100%",
    height: "100%",
    ".swiper-slide span": {
      height: "100% !important",
      width: "100% !important"
    }
  }
});

const scaleAnim = keyframes`
  from { transform: scale(0); opacity: 0; }
  to { transform: scale(1); opacity: 1;}
`;

export const ZoomContainer = chakra(Box, {
  baseStyle: {
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: colours.secondary.light,
    // zIndex of floating help button is 999998
    zIndex: 1000001,
    animation: `${scaleAnim} 0.2s ease-out`
  }
});

export const ThumbsContainer = chakra(Box, {
  baseStyle: {
    background: colours.secondary.light,
    zIndex: 1000003,
    height: { base: "5rem", md: "6rem" },
    borderTop: `1px solid ${colours.primary.dark}`
  }
});

export const CloseButton = chakra(Flex, {
  baseStyle: {
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    borderLeft: `1px solid ${colours.primary.dark}`,
    _active: {
      background: colours.primary.dark,
      "& svg path": {
        fill: colours.primary.dark
      }
    }
  }
});

export const ZoomButton = chakra(Flex, {
  baseStyle: {
    background: colours.transparency.medium,
    cursor: "pointer",
    zIndex: 1000004,
    width: "3rem",
    height: "3rem",
    position: "absolute",
    right: { base: space[1], md: space[2] },
    marginBottom: { base: space[1], md: space[2] },
    justifyContent: "center",
    alignItems: "center",
    boxShadow: shadows.shadow1,
    _active: {
      background: colours.primary.dark,
      "& svg path": {
        fill: colours.secondary.light
      }
    }
  }
});

export const SwiperNavButton = chakra(Box, {
  baseStyle: {
    width: "2.5rem !important",
    height: "2.5rem !important",
    mt: 0,
    visibility: "visible !important",
    background: colours.secondary.light,
    "@media (hover: hover)": {
      "&:hover": {
        border: `1px solid ${colours.secondary.deep}`
      }
    }
  }
});
